<template>
  <div class="container">
    <div class="block">
      <div class="card" style="margin-bottom: 10px">
        <div class="card-content">
          <div class="media">
            <!-- Left pane -->
            <div class="media-left">
              <!-- Product image -->
              <figure class="image" style="width: 96px">
                <img
                  style="max-height: 96px; max-width: 96px"
                  :src="'data:image/jpeg;base64,' + image"
                  alt="Placeholder image"
                />
              </figure>
              <!-- Manufacturers and suppliers -->
              <div class="container">
                <div class="grid-container">
                  <div class="grid-item">
                    <!-- Manufacturer -->
                    <button
                      class="g-button tooltip"
                      @click="manufacturerButtonClicked([manufacturerId])"
                    >
                      <img
                        style="max-height: 18px; max-width: 72px"
                        :src="'data:image/jpeg;base64,' + manufacturerImage"
                        alt="Placeholder image"
                      />
                      <span class="tooltiptext"
                        ><small
                          >prikaži samo {{ manufacturerName }}</small
                        ></span
                      >
                    </button>
                  </div>
                  <div class="grid-item">
                    <!-- <button class="g-button">Supplier</button> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- Right pane -->
            <div class="media-content">
              <!-- name, promo, etc -->
              <div @click="closeTypeExpanderIfOpened">
                <div class="container">
                  <div class="flexbox-container-name">
                    <div class="flexbox-item-name">
                      <!-- promo -->
                      <a v-if="isPromo">
                        <img
                          src="../assets/hot-price.png"
                          width="40"
                          height="28"
                        />
                      </a>
                    </div>
                    <div class="flexbox-item-name">
                      <!-- name -->
                      <p class="title is-4">
                        {{ manufacturerName }}
                        <span
                          class="a"
                          style="margin-left: 5px; font-weight: 700"
                          v-html="name"
                        ></span>
                      </p>
                    </div>
                    <div class="flexbox-item-name">
                      <!-- is favourite -->
                      <a class="">
                        <span class="icon is-small"
                          ><i class="fa fa-heart-o"></i
                        ></span>
                      </a>
                    </div>
                    <div class="flexbox-item-name">
                      <!-- itemsOnStock -->
                      <a class="">
                        <label>{{ itemsOnStock }}</label>
                      </a>
                    </div>
                    <div class="flexbox-item-name">
                      <!-- add button -->
                      <div class="">
                        <button
                          class="button is-info is-light is-rounded is-medium"
                        >
                          <nav class="icon">
                            <i class="fa fa-lg fa-plus"></i>
                          </nav>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- description -->
              <p
                class="content is-small a"
                v-html="description"
                @click="closeTypeExpanderIfOpened"
              ></p>
              <!-- Categores list -->
              <div class="Accordion" @click="calculateTypeTrain">
                <expander
                  title="lista kategorija"
                  animation="bounceIn"
                  ref="expander"
                >
                  <div class="cont_breadcrumbs_3">
                    <ul class="breadcrumb">
                      <li v-for="tn in commercialTypeNumbers" :key="tn.id">
                        <a @click="categoryChosen(tn.id)">{{ tn.name }}</a>
                      </li>
                    </ul>
                  </div>
                </expander>
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <p class="card-footer-item">
            <span>
              <p class="content is-medium">{{ globalPrice | currency }}</p>
            </span>
          </p>
          <p class="card-footer-item">
            <span>
              Share on <a href=""><i class="fa fa-facebook"></i>acebook</a>
            </span>
          </p>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import Expander from "./helpers/Expander";
import { mapActions, mapMutations } from "vuex";

export default {
  name: "Product",

  components: { Expander },

  props: {
    name: String,
    description: String,
    globalPrice: Number,
    image: String,
    typeTrain: String,
    manufacturerId: Number,
    manufacturerName: String,
    manufacturerImage: String,
    supplierArray: Array,
    isFavorite: Boolean,
    isPromo: Number,
    commercialTypeNumber: String,
    itemsOnStock: Number, // - in suppliers array
  },

  data() {
    return {
      commercialTypeNumbers: [],
    };
  },

  methods: {
    ...mapActions(["setSelectedCategoryId", "executeSearch"]),
    ...mapMutations(["updateFilteredManufacturerIds", "SET_PROMO"]),
    closeTypeExpanderIfOpened() {
      this.$refs.expander.open = false;
    },
    calculateTypeTrain() {
      this.commercialTypeNumbers = [];
      let ctnArray = this.commercialTypeNumber.split(" ");
      // remove empty string from the array
      ctnArray.splice(ctnArray.indexOf(""), 1);
      ctnArray.forEach((ctn) => {
        let myId = ctn;

        // find type name from id
        let name = this.$store.state.cdata.find((c) => c.typeId == myId).name;
        let vagon = {
          id: ctn,
          name: name,
        };
        this.commercialTypeNumbers.push(vagon);
      });
    },
    categoryChosen(categoryId) {
      this.setSelectedCategoryId(categoryId);
    },
    manufacturerButtonClicked(manufacturerArray) {
      this.updateFilteredManufacturerIds(manufacturerArray);
      this.SET_PROMO(false);
      this.executeSearch();
    },
  },

  filters: {
    currency(value) {
      return new Intl.NumberFormat("sr-SP", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
  },
};
</script>

<style scoped>
/* .is-horizontal-center {
  justify-content: center;
}
.is-vertical-center {
  justify-content: center;
} */
.grid-container {
  display: grid;
  grid-template-columns: auto;
  /* background-color: #2196f3; */
  padding: 2px;
}

.grid-item {
  background-color: rgba(255, 255, 255, 0.8);
  border: 0px solid rgba(0, 0, 0, 0.8);
  padding: 2px;
  font-size: 3px;
  text-align: center;
}

.flexbox-container-name {
  display: flex;
  flex-wrap: wrap;
  /* margin: -0.5rem; */
  align-items: center;
}
.flexbox-item-name {
  /* background-color: orange; */
  /* border: 1px solid rgba(43, 151, 85, 0.678); */
  padding: 2px;
  /* margin: 0.5rem; */
}

.g-button {
  border: 1px solid rgba(43, 151, 85, 0.678);
  width: 100%;
}

.tooltip {
  position: relative;
  display: inline-block;
  /* border-bottom: 1px dotted black; */
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.a >>> em {
  background-color: yellow;
}

/* breadcrumb */
.cont_breadcrumbs_3 > ul > li {
  position: relative;
  float: left;
  background-color: #fff;
  z-index: 1;
  transition: all 0.5s;
  margin-left: 5px;
}

.cont_breadcrumbs_3 > ul > li:hover {
  background-color: #cfd8dc;
}

.cont_breadcrumbs_3 > ul > li > a {
  display: block;
  padding: 3px;
  font-size: x-small;
  /* text-decoration: none; */
  color: #444;
  font-weight: 300;
}

/* Add a slash symbol (/) before/behind each list item */
.cont_breadcrumbs_3 > ul > li + li:before {
  padding: 2px;
  position: relative;
  display: block;
  color: black;
  content: "\27a2";
}

ul.breadcrumb {
  list-style: none;
  background-color: #eee;
}
ul.breadcrumb li {
  font-size: x-small;
}
ul.breadcrumb li a {
  color: #0275d8;
  text-decoration: none;
}
ul.breadcrumb li a:hover {
  color: #01447e;
  text-decoration: underline;
}
</style>
